var map = {
	"./cover-0.jpg": "4758",
	"./cover-1.jpg": "1cac",
	"./cover-2.jpg": "2428",
	"./cover-3.jpg": "35cb",
	"./cover-4.jpg": "4bf4",
	"./cover-5.jpg": "130a",
	"./cover-6.jpg": "d3f7",
	"./cover-7.jpg": "0492",
	"./cover-8.jpg": "d1e5",
	"./cover-9.jpg": "e071"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "85e9";